"use client"

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb"
import { BOOKING_STEP_LABELS } from "@/store/appointment-store"
import { observer } from "mobx-react-lite"
import { useStore } from "@/app/components/common/store.provider"

export const AppointmentCrumbs = observer(function AppointmentCrumbs() {
  const { appointmentStore } = useStore()
  const currentStep = appointmentStore.currentStep
  const steps = appointmentStore.steps

  return (
    <Breadcrumb>
      <BreadcrumbList className="flex-wrap gap-1">
        {steps.flatMap((stepId, index) => {
          const stepNumber = index + 1
          const label = BOOKING_STEP_LABELS[stepId]

          return [
            <BreadcrumbItem key={stepId}>
              {stepNumber === currentStep ? (
                <BreadcrumbPage className="min-h-11 px-2 py-2 font-medium">
                  {label}
                </BreadcrumbPage>
              ) : stepNumber < currentStep ? (
                <BreadcrumbLink asChild className="cursor-pointer hover:text-foreground">
                  <button
                    type="button"
                    onClick={() => appointmentStore.setCurrentStep(stepNumber)}
                    className="min-h-11 px-2 py-2 text-muted-foreground"
                  >
                    {label}
                  </button>
                </BreadcrumbLink>
              ) : (
                <span className="min-h-11 px-2 py-2 text-muted-foreground/50">{label}</span>
              )}
            </BreadcrumbItem>,
            ...(index < steps.length - 1
              ? [<BreadcrumbSeparator key={`sep-${stepId}`} />]
              : []),
          ]
        })}
      </BreadcrumbList>
    </Breadcrumb>
  )
})
